import * as XLSX from "xlsx";

export async function parseQuestionFile(file) {
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: "array" });

    const firstSheetName = workbook.SheetNames[0];

    if (!firstSheetName) {
        throw new Error("檔案沒有工作表");
    }

    const sheet = workbook.Sheets[firstSheetName];
    const rows = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        defval: "",
        blankrows: true,
    });

    const headers = (rows[0] || []).map((value) =>
        String(value).trim()
    );

    const noIndex = headers.findIndex(
        (name) => name === "編號" || name.toLowerCase() === "id"
    );

    const textIndex = headers.findIndex(
        (name) => name === "對話文本" || name.toLowerCase() === "text"
    );

    if (noIndex === -1 || textIndex === -1) {
        throw new Error("第一列需包含「編號」與「對話文本」，也接受 id、text");
    }

    const items = [];
    const errors = [];
    const seenNos = new Map();

    rows.slice(1).forEach((row, index) => {
        const rowNumber = index + 2;

        const isEmptyRow = row.every(
            (value) => String(value).trim() === ""
        );

        if (isEmptyRow) return;

        const no = String(row[noIndex] ?? "").trim();
        const text = String(row[textIndex] ?? "").trim();

        if (!no) {
            errors.push(`第 ${rowNumber} 列：編號不可空白`);
        } else if (seenNos.has(no)) {
            errors.push(
                `第 ${rowNumber} 列：編號 ${no} 與第 ${seenNos.get(no)} 列重複`
            );
        } else {
            seenNos.set(no, rowNumber);
        }

        if (!text) {
            errors.push(`第 ${rowNumber} 列：對話文本不可空白`);
        }

        items.push({ no, text });
    });

    if (items.length === 0) {
        errors.push("檔案沒有題目資料");
    }

    if (errors.length > 0) {
        throw new Error(errors.join("\n"));
    }

    return items;
}

export function downloadQuestionTemplate() {
  const rows = [
    ["編號", "對話文本"],
    [1, "老師：植物需要什麼才能生長？學生：需要陽光和水。"],
    [2, "老師：植物需要什麼才能生長？學生：我昨天去看電影。"],
    [3, "老師：為什麼植物需要陽光？學生：植物利用陽光進行光合作用。"],
  ];

  const sheet = XLSX.utils.aoa_to_sheet(rows);

  sheet["!cols"] = [
    { wch: 10 },
    { wch: 70 },
  ];

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, sheet, "題目");

  XLSX.writeFile(workbook, "問答驗證題目範本.xlsx");
}

export async function parseHumanResultFile(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheetName = workbook.SheetNames[0];

  if (!sheetName) {
    throw new Error("檔案沒有工作表");
  }

  const rows = XLSX.utils.sheet_to_json(
    workbook.Sheets[sheetName],
    { header: 1, defval: "", blankrows: true }
  );

  const headers = (rows[0] || []).map((value) =>
    String(value).trim()
  );

  const noIndex = headers.indexOf("編號");
  const resultIndex = headers.indexOf("結果");

  if (noIndex === -1 || resultIndex === -1) {
    throw new Error("第一列需包含「編號」與「結果」");
  }

  const entries = [];

  rows.slice(1).forEach((row, index) => {
    if (row.every((value) => String(value).trim() === "")) {
      return;
    }

    entries.push({
      rowNumber: index + 2,
      no: String(row[noIndex] ?? "").trim(),
      value: String(row[resultIndex] ?? "").trim(),
    });
  });

  if (!entries.length) {
    throw new Error("檔案沒有人工編碼結果");
  }

  return entries;
}